<template>
  <div class="donations-screen">
    <aside class="sidebar">
      <h2 class="sidebar-title">{{ eventTitle }}</h2>
      <ul class="nav-menu">
        <li @click="navigateTo('Dashboard')" class="nav-item">Dashboard</li>
        <li @click="navigateTo('Invitees')" class="nav-item">Invitees</li>
        <li @click="navigateTo('Donations')" class="nav-item active">Donations</li>
        <li @click="logout" class="nav-item logout">Logout</li>
      </ul>
    </aside>

    <main class="main-content">
      <h1 class="main-title">Gala Dinner</h1>

      <input
        type="text"
        v-model="searchQuery"
        placeholder="Search by name"
        class="search-box"
      />

      <div class="donations-list">
        <div class="donation-row donation-header">
          <span>Name</span>
          <span>Table Number</span>
          <span>Amount Donated</span>
        </div>

        <div
          v-for="invitee in filteredDonors"
          :key="invitee.id"
          class="donation-row"
        >
          <span>{{ invitee.firstName }} {{ invitee.lastName }}</span>
          <span>{{ invitee.tableNumber }}</span>
          <span :class="{'highlighted': invitee.donated > 0}">${{ invitee.donated }}</span>
        </div>
      </div>

      <div class="total-donations">
        Total Donations: ${{ totalDonations }}
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      eventTitle: "Gala Dinner",
      searchQuery: "",
      invitees: [
        {
          id: 1,
          firstName: "John",
          lastName: "Doe",
          tableNumber: 1,
          donated: 100,
        },
        {
          id: 2,
          firstName: "Jane",
          lastName: "Smith",
          tableNumber: 2,
          donated: 50,
        },
      ],
    };
  },
  computed: {
    filteredDonors() {
      return this.invitees.filter(
        (invitee) =>
          invitee.donated > 0 &&
          (invitee.firstName + " " + invitee.lastName)
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
      );
    },
    totalDonations() {
      return this.invitees.reduce((total, invitee) => total + invitee.donated, 0);
    },
  },
  methods: {
    navigateTo(page) {
      this.$router.push({ name: page });
    },
    logout() {
      this.$router.push({ name: "Login" }); // Navigate to login screen on logout
    },
  },
};
</script>

<style scoped>
.donations-screen {
  display: flex;
  /*background-color: #001643;*/
  color: white;
  height: 100vh;
}

.sidebar {
  width: 250px;
  /*background-color: #001643;*/
  padding: 1rem;
}

.sidebar-title {
  color: #ff6b35;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.nav-menu {
  list-style: none;
  padding: 0;
}

.nav-item {
  cursor: pointer;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  font-size: 1.1rem;
  color: #00cfff;
}

.nav-item.active {
  font-weight: bold;
}

.logout {
  color: #ff6b35;
  font-weight: bold;
}

.main-content {
  flex: 1;
  padding: 2rem;
}

.main-title {
  color: #ff6b35;
  font-size: 2rem;
}

.search-box {
  padding: 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
  font-size: 1rem;
}

.donations-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
}

.donation-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #003366;
}

.donation-header {
  font-weight: bold;
}

.highlighted {
  color: #00cfff;
}

.total-donations {
  font-size: 1.2rem;
  font-weight: bold;
  color: #ff6b35;
  margin-top: 1.5rem;
}
</style>
